import AdminShell from "@/components/admin/AdminShell";
import AcademyMediaManager from "@/components/admin/AcademyMediaManager";

export default function AdminLogicMedia() {
  return (
    <AdminShell title="Stoic Logic · Media Slots">
      <div data-testid="admin-logic-media-page">
        <AcademyMediaManager discipline="logic" />
      </div>
    </AdminShell>
  );
}
